export enum MmuDeviceType {
  WM = 'wm', // Washing Machine
  SPWM = 'spwm', // Semi-Professional Washing Machine
  PWM = 'pwm', // Professional Washing Machine
  TD = 'td', // Tumble Dryer
  SPTD = 'sptd', // Semi-Professional Tumble Dryer
  PTD = 'ptd', // Professional Tumble Dryer
  DW = 'dw', // Dishwasher
  SPDW = 'spdw', // Semi-Professional Dishwasher
  PDW = 'pdw', // Professional Dishwasher
  PWD = 'pwd', // Professional Washer-Disinfector
  /**
   * @deprecated
   * PWD K23 is deprecated, please use PWD_K23_LAB, PWD_K23_MED or PWD_K23_FIRE
   */
  PWD_K23 = 'pwd_k23', // Professional Washer-Disinfector K23
  PWD_K23_LAB = 'pwd_k23_lab', // Professional Washer-Disinfector K23 (Laboratory)
  PWD_K23_MED = 'pwd_k23_med', // Professional Washer-Disinfector K23 (Medical)
  PWD_K23_FIRE = 'pwd_k23_fire', // Professional Washer-Disinfector K23 (Fire Brigade)
  PWD_SLIMLINE = 'pwd_slimline', // Professional Washer-Disinfector Slimline (Medical)
  STEAM_STERILIZER_CUBE = 'cube', // Sterilizer
  /**
   * @deprecated
   */
  STEAM_STERILIZER_CUBE_OLD = 'steam_sterilizer_cube' // Sterilizer
}
